module.exports = __webpack_public_path__ + "images/a463d227.DMS_loading.gif";


//////////////////
// WEBPACK FOOTER
// ./core-dms/projects/candao-dms-std/static/images/DMS_loading.gif
// module id = 229
// module chunks = 130 131 132 133 134 135